// extracted by css-extract-rspack-plugin
export default {"link":"link--prmaPoVYdXEV1BRl","wrapper":"wrapper--DNjIaeHwARZ5v2E2"};